var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThanks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6603 19.1085H17.3258C18.0328 19.1085 18.7108 18.8276 19.2107 18.3277C19.7105 17.8278 19.9914 17.1498 19.9914 16.4429C19.9914 15.736 19.7105 15.058 19.2107 14.5581C18.7108 14.0582 18.0328 13.7773 17.3258 13.7773H13.3275C12.5278 13.7773 11.8614 14.0439 11.4616 14.577L3.99805 21.774",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2582 18.2976L25.9888 12.0416C26.9164 11.1139 27.9879 9.58124 27.9879 8.11519C27.9881 7.3733 27.7631 6.64882 27.3427 6.03754C26.9224 5.42625 26.3264 4.95692 25.6335 4.69161C24.9407 4.42629 24.1837 4.37748 23.4625 4.55161C22.7414 4.72575 22.09 5.11464 21.5946 5.66687C21.5602 5.70427 21.5183 5.73412 21.4718 5.75454C21.4252 5.77496 21.3749 5.7855 21.324 5.7855C21.2732 5.7855 21.2229 5.77496 21.1763 5.75454C21.1298 5.73412 21.0879 5.70427 21.0535 5.66687C20.5581 5.11464 19.9067 4.72575 19.1856 4.55161C18.4644 4.37748 17.7074 4.42629 17.0146 4.69161C16.3217 4.95692 15.7257 5.42625 15.3054 6.03754C14.885 6.64882 14.66 7.3733 14.6602 8.11519C14.6602 9.71452 15.729 11.1113 16.6593 12.0416L21.324 16.3784",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 20.4414L10.6627 28.4381",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33008 27.1075L11.4625 25.2416C11.8624 24.7085 12.5287 24.4419 13.3284 24.4419H18.6595C20.1256 24.4419 21.4584 23.9088 22.3913 22.8426L28.5221 16.9784C29.0364 16.4924 29.3366 15.8219 29.3566 15.1146C29.3765 14.4073 29.1147 13.7209 28.6287 13.2066C28.1427 12.6923 27.4722 12.3922 26.7649 12.3722C26.0576 12.3522 25.3712 12.614 24.8569 13.1",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.ba7374111bc544d196dbe2ee610595f6.svg";
export { ForwardRef as ReactComponent };